import app_config from '../config/app/config'

export const getLangFromUrl = () => app_config.langDefault
